import { Spin } from 'antd';

import { PageMetadata } from '@suntex.fim/framework';

import { useModuleAccess, usePlayer } from '../../hooks';
import { getPlayerGradeLevel } from '../../utils/focus';

import { ContentLibrary } from './ContentLibrary';

export function ContentLibraryPage() {
  const { enabledModules, moduleTagging, isLoading } = useModuleAccess();
  const { playerInfo } = usePlayer();

  if (isLoading || !enabledModules || !moduleTagging) return <Spin />;

  return (
    <>
      <PageMetadata title="Content Library" />
      <ContentLibrary
        modules={enabledModules}
        moduleTagging={moduleTagging}
        gradeLevel={getPlayerGradeLevel(playerInfo)}
      />
    </>
  );
}
